import script from "./DictionaryIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryIndex.vue?vue&type=script&setup=true&lang=js"

import "./DictionaryIndex.vue?vue&type=style&index=0&id=12e765a5&lang=css"
import "./DictionaryIndex.vue?vue&type=style&index=1&id=12e765a5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e765a5"]])

export default __exports__